// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { SagaObject } from '../../SagaBase/SagaObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ResVideo_abstract extends SagaObject {
  static $t: string = 'SagaSchema.ResVideo';
  $t: string = 'SagaSchema.ResVideo';

  public static GetMembers(): string[] {
    return ['ResResourceUId', 'VideoProviderDB', 'VideoUri'].concat(SagaObject.GetMembers());
  }

  public GetMembers(): string[] {
    return ResVideo_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ResResourceUId: Guid = GuidTools.Empty;
  public VideoProviderDB: number = 0;
  public VideoUri: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return this.ResResourceUId;
  }
  set ParentObjId(value: any) {
    this.ResResourceUId = value;
  }

  /*</AUTO_IMPLEMENTATION>*/
}
